export default __webpack_public_path__ + "static/media/myPlants.457efd3c.jpg";